import BookItem from "../common/bookItem";
export default class VisibleSwitchAnsStep extends BookItem {
    constructor(el, target) {
        super(el, target);

        this.ctrlObjStep = this.el.ctrlObjStep;
        this.connectNumber = this.el.connectNumber;

        /**
         * 上一步按鈕
         */
        this.storeUp = null;

        /**
         * 下一步按鈕
         */
        this.storeDown = null;

        /**
         * 子物件
         */
        this.childObj = null;

        /**
         * 子物件連續圖
         */
        this.rowPicObj = [];

        this.add_mouse_event();

        if (this.ctrlObjStep == "上一個") {
            this.target.gotoAndStop(2);
        }
        else {
            this.target.gotoAndStop(0);
        }
    }

    //逐步解答(數)done

    init() {
        /**
         * 暫存getItemsByClassConnect的陣列後續使用
         */
        let tempStep = [];

        tempStep = this.itemControl.getItemsByClassConnect("stepbtn", this);

        tempStep.forEach(element => {
            if (element.ctrlObjStep == "上一個") {
                this.storeUp = element;
            }
            else if (element.ctrlObjStep == "下一個") {
                this.storeDown = element;
            }
        });
    }

    trigger() {
        const self = this;
        if (self.ctrlObjStep == "下一個") {
            if (self.childObj.target.currentFrame == self.childObj.target.totalFrames - 1) {
                // console.log("滿了不做了");
                return;
            }

            // self.childObj.target.gotoAndStop(self.childObj.target.currentFrame + 1);
            self.childObj.target.gotoAndStop(self.childObj.target.currentFrame + 1);

            // self.storeUp[0].target.gotoAndStop(0);
            self.storeUp.target.gotoAndStop(0);
            self.storeUp.target.mouseEnabled = true;

            //如果開到子物件影格最後一個，下箭頭要做事
            if (self.childObj.target.currentFrame == self.childObj.target.totalFrames - 1) {
                self.storeDown.target.gotoAndStop(2);
                self.storeDown.target.mouseEnabled = false;
                self.childObj.isOpen = true;
            }
        }
        else {
            if (self.childObj.target.currentFrame == 0) {
                // console.log("少了不做了");
                return;
            }

            self.childObj.isOpen = false;

            self.childObj.target.gotoAndStop(self.childObj.target.currentFrame - 1);
            self.storeDown.target.gotoAndStop(0);
            self.storeDown.target.mouseEnabled = true;

            //如果開到子物件影格第一個，上箭頭要做事
            if (self.childObj.target.currentFrame == 0) {
                self.storeUp.target.gotoAndStop(2);
                self.storeUp.target.mouseEnabled = false;
            }
        }

        // console.log("self.childObj.isOpen",self.childObj.isOpen);

        //處理連續圖物件
        self.rowPicObj.forEach(obj => {
            if (self.childObj.target.currentFrame + 1 < obj.ctrlObjOrder) {
                //還沒要開的物件
                obj.target.visible = false;
            }
            else if (self.childObj.target.currentFrame + 1 == obj.ctrlObjOrder) {
                //開囉
                obj.target.visible = true;
                self.play_ani(obj);
            }
            else if (self.childObj.target.currentFrame + 1 > obj.ctrlObjOrder) {
                obj.target.gotoAndStop(obj.target.totalFrames - 1);
            }
        });

        self.ChildNotice();
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            if (this.target.currentFrame == 2) return;
            this.target.gotoAndStop(0);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mouseover", () => {
            if (this.target.currentFrame == 2) return;
            if (this.target.currentFrame == 1) return;
            this.target.gotoAndStop(1);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mouseout", () => {
            if (this.target.currentFrame == 2) return;
            this.target.gotoAndStop(0);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
    }

    play_ani(obj) {
        obj.target.gotoAndStop(0);
        if (!obj.itemControl.loader.antialiasingMovieClips.includes(obj.target)) {
            obj.itemControl.loader.antialiasingMovieClips.push(obj.target);
        }
        obj.target.play();
        obj.target.loop = 0;
    }
}